import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";

import { LatestDiscoveryWidget } from "scmp-app/components/rhs-module/latest-discovery-widget";
import type { chinaScienceDiscoveryWidgetQuery$key } from "scmp-app/queries/__generated__/chinaScienceDiscoveryWidgetQuery.graphql";

type Props = {
  className?: string;
  desktopItemCount?: number;
  reference: chinaScienceDiscoveryWidgetQuery$key;
};

export const ChinaScienceDiscoveryWidget: FunctionComponent<Props> = ({
  className,
  desktopItemCount,
  reference,
}) => {
  const data = useFragment(
    graphql`
      fragment chinaScienceDiscoveryWidgetQuery on Query {
        chinaScienceSection: section(filter: { entityId: "328475" }) {
          ...latestDiscoveryWidgetSection
        }
        chinaScienceQueue: queue(filter: { name: "section_top_328475" }) {
          ...latestDiscoveryWidgetQueue
        }
      }
    `,
    reference,
  );
  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.LatestChinaScience,
      }}
    >
      <LatestDiscoveryWidget
        className={className}
        desktopItemCount={desktopItemCount}
        overrideSectionName="China Science"
        queueReference={data.chinaScienceQueue}
        sectionReference={data.chinaScienceSection}
      />
    </BaseLinkContextProvider>
  );
};

ChinaScienceDiscoveryWidget.displayName = "ChinaScienceDiscoveryWidget";
